// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action-buttons[data-v-77c21909]{margin-bottom:0;margin-top:45px}", "",{"version":3,"sources":["webpack://./resources/js/views/pages/calendar/Single.vue"],"names":[],"mappings":"AAAA,iCAAA,eAAA,CAAA,eAAA","sourcesContent":[".action-buttons{margin-top:45px;margin-bottom:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
